// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"29f82f1a","869":"514829a7"}[chunkId] + ".chunk.js";
};